import type { BrandContextMode, DirectorOverride, TestConfigPayload } from './tipos';

/**
 * Etiquetas del modo automático — las comparten el editor de configs (los selects) y
 * el resumen del lightbox de comparación, así lo que elegís y lo que después leés al
 * votar dicen exactamente lo mismo.
 * ADR-2026-08-26-modo-automatico-en-el-test-masivo.
 */

/** Opciones del selector de director de arte. `''` = el de producción (no manda la key). */
export const DIRECTORES: Array<{ value: DirectorOverride | ''; label: string }> = [
  { value: '', label: 'El de producción (Gemini 3 Flash)' },
  { value: 'gemini-3-flash-preview', label: 'Gemini 3 Flash' },
  { value: 'gpt-5.6-sol', label: 'GPT-5.6 Sol' },
];

export const ANALISIS_MODES: Array<{ value: BrandContextMode; label: string }> = [
  { value: 'real', label: 'El real de la marca' },
  { value: 'sin_analisis', label: 'Sin análisis (plantilla por rubro)' },
  { value: 'texto', label: 'Texto propio' },
];

/** Máximo del informe inventado en el resumen: es una línea de una tabla, no el informe. */
const RECORTE = 140;

export function etiquetaDirector(v: DirectorOverride | null | undefined): string {
  if (v === 'gpt-5.6-sol') return 'GPT-5.6 Sol';
  if (v === 'gemini-3-flash-preview') return 'Gemini 3 Flash';
  return 'Gemini 3 Flash (el de producción)';
}

export function etiquetaAnalisis(
  p: Pick<TestConfigPayload, 'brand_context_mode' | 'brand_context_texto'>,
): string {
  if (p.brand_context_mode === 'sin_analisis') return 'Ninguno — plantilla por rubro';
  if (p.brand_context_mode === 'texto') {
    const texto = (p.brand_context_texto ?? '').trim();
    // Sin texto el backend cae en la plantilla SIN informe: decirlo evita leer una
    // corrida como "con informe propio" cuando en realidad corrió sin ninguno.
    if (!texto) return 'Texto propio vacío — corre sin informe';
    return texto.length > RECORTE ? `“${texto.slice(0, RECORTE)}…”` : `“${texto}”`;
  }
  return 'El real de la marca';
}
